import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { FormField } from './FormField';
import type { DatePickerProps } from 'antd';
import type { FormFieldProps } from './FormField';
import type { ControllerFieldState } from 'react-hook-form';

export type DatePickerFieldProps = FormFieldProps &
    DatePickerProps & {
        fieldState?: ControllerFieldState;
    };

export const DatePickerField = ({
    value,
    format = 'DD/MM/YYYY',
    fieldState,
    disabled = false,
    showValidationIcon,
    error,
    correct,
    ...props
}: DatePickerFieldProps) => {
    const errorMessage = error || fieldState?.error?.message;
    const isValid = correct || (fieldState?.isDirty && !fieldState?.error?.message);

    const getInputClassName = () => {
        if (errorMessage) {
            return 'incorrect';
        }

        if (isValid) {
            return 'correct';
        }

        return '';
    };

    const singleValue = Array.isArray(value) ? value[0] : value;
    const inputValue = singleValue ? dayjs(singleValue, format as string) : undefined;

    return (
        <FormField
            {...props}
            fieldState={fieldState}
            labelFor={props?.id || props.name}
            error={error}
            correct={correct}
            showValidationIcon={showValidationIcon}>
            <DatePicker
                {...props}
                id={props?.id || props.name}
                className={getInputClassName()}
                aria-invalid={fieldState?.invalid ? 'true' : 'false'}
                disabled={disabled}
                format={format}
                value={inputValue}
            />
        </FormField>
    );
};
